module.exports = __webpack_public_path__ + "static/assets/7176aa6fc1d9d4bc12dc35951a7fdfe0.gif";